<novo-data-table 
    [dataTableService]="remoteService"
    [columns]="sharedColumns"
    [allowMultipleFilters]="true"
    [displayedColumns]="sharedDisplayColumns"
    [hideGlobalSearch]="true"
    [selectionOptions]="selectionOptions"
    [paginationOptions]="paginationOptions"
    name="cubex-monster-jobs"
    [activeRowIdentifier]="selectedRecordId"
    *ngIf="!loading"
    #basic>
     <ng-template novoTemplate="expandedRow"
      let-row>
      <table>
        <tr>
          <th> </th>
          <th>Candidate</th>
          <th>Candidate Owner</th>
          <th>Submission Status</th>
        </tr>
        <tr *ngFor="let submission of row.submissions.data">
          <td>
            <button theme="primary" (click)="addTarget(submission)">Target</button>
          </td>

          <td>
            <div style="display: flex; align-items: end;">
              <button [disabled]="targetSubmitted[submission.id]" [loading]="targetLoading[submission.id]" theme="icon" icon="preview" (click)="preview(submission.candidate, submission)"></button>
              <novo-value [data]="submission.candidate" [meta]="candidateFieldMeta" ></novo-value>
            </div>
          </td>
          <td><novo-value [data]="submission.candidate.owner" [meta]="ownerFieldMeta" ></novo-value></td>
          <td>{{submission.status}}</td>
        </tr>
      </table>

    </ng-template> 
    <ng-template novoTemplate="owner"
    let-row>
      <novo-value [data]="row.owner" [meta]="ownerFieldMeta"></novo-value>
    </ng-template>
    <ng-template novoTemplate="candidateOwner" let-row>
      <novo-value [data]="row.owner" [meta]="ownerFieldMeta"></novo-value>
    </ng-template>
    <ng-template novoTemplate="clientCorporation"
    let-row>
      <novo-value [data]="row.clientCorporation" [meta]="companyFieldMeta" ></novo-value>
    </ng-template>
    <ng-template novoTemplate="title"
    let-row>
      <novo-value [data]="row" [meta]="jobFieldMeta" ></novo-value>
    </ng-template>
  </novo-data-table>
  <novo-tip-well *ngIf="filterConfigText" name="Filters" [sanitize]="false" [tip]="filterConfigText" [button]="false"></novo-tip-well>
